module.exports = __webpack_public_path__ + "img/hr-level3addon_mining_hands.81211003.png";